import React, { Component } from 'react';
import Header from '../.././Header';
import Image from '../.././Image';
import classnames from 'classnames';

export default class sgBEAT extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    const slug = "sgbeat";
    const screenshots = [
      {id: 'sgbeat-1', title: 'sgBEAT', content: 'A simple and clean font preceded by the pulse icon, colored red and white representing Singapore\'s national colors and contrasts nicely against a dark, black background. Font used: Lane Narrow.'},
      {id: 'sgbeat-2', title: 'Pulse', content: 'The sgBEAT icon is designed in the form of a pulse signal which represents the service as a heartbeat of Singapore. Sharp and straight lines present a modern look to the brand.'},
      {id: 'sgbeat-3', title: 'Banner Advertisements', content: 'A series of banner advertisements that promotes the different features of the service. Designed to be simple with a title and clear value proposition to the user.'},
      {id: 'sgbeat-4', title: 'Beat Roulette', content: 'The scales of the Beat Roulette logo mimics the metallic lights of Las Vegas as it stands against a red velvet backdrop. Font used: Milford Black.'},
      {id: 'sgbeat-5', title: 'sgBEAT Lens', content: 'Lens is a gallery of visual beats contributed by the members of the sgBEAT community. Users can send in photographs via MMS or upload images directly from their desktops. sgBEAT Lens had over 3,000 images posted.'},
      {id: 'sgbeat-6', title: 'Profile Page', content: 'The profile page shows the user the latest beats in his or her stream, as well as other profile details like badges and followers. The beat box allows users to quickly post messages, with controls as shown through the icons.'},
    ];

    return (
      <div className={classnames('sgBEAT', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">sgBEAT</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Make microblogging via SMS easier in Singapore</li>
                  <li><strong>Role</strong>: Co-founder and designer</li>
                  <li><strong>Team</strong>: Hongping Lim, Kah Keng Tay, Kah Seng Tay</li>
                  <li><strong>Duration</strong>: Feb 2009—Dec 2010 (1 year 11 months)</li>
                </ul>
              </div>
              <div className="section-title">Highlights</div>
              <div className="section-copy">
                <ul>
                  <li>Reached over 40K users, 170K monthly unique visitors, 2.5M pageviews and 10M SMS transacted as of December 2010</li>
                  <li>Successfully developed a community of passionate early adopters and power users through Facebook and Twitter</li>
                  <li>Negotiated partnerships with over 40 local vendors to provide discounts to members of the community</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  sgBEAT was Singapore's largest microblogging service. I co-founded the service with Hongping Lim, Kah Keng Tay and Kah Seng Tay in early 2009. I wore multiple hats during this time, including designing the product interface and interactions, managing user relations and developing partnerships with local businesses.
                </p>
                <p>
                  <strong>Problem:</strong> Updating Facebook and Twitter via SMS was available in the United States, but limited internationally. Not many people in Singapore had smartphones at that time, so they could only use those services on their personal computers. There was clearly a need for a local service that integrated with them.
                </p>
                <p>
                  <strong>Approach:</strong> We integrated a local SIM card with a server and launched sgBEAT; it was the first service in Singapore to support posting to Twitter, Facebook and Plurk via SMS. The service also had advanced features like MMS support, SMS replies, trending topics and conversation view (even before Twitter did). It quickly gained traction among youths in Singapore. 
                </p>
                <p>
                  There were a number of competing services in Singapore during this time, notably MobiTweet which was launched by a telco in Singapore. Yet, we iterated the product rapidly to stay ahead of the competition. We also explored different business models, such as partnerships with local brands, as well as advertising.
                </p>
                <p>
                  However, as smartphone adoption in Singapore increased, many of our users grew less dependent on SMS as a means of posting status updates. Our growth declined slowly, and as this was a side project for us, we eventually decided to stop maintaining the service.
                </p>
              </div>
              <div className="section-title">Designs</div>
              <div className="section-images">
                {
                  Object.keys(screenshots).map(function(key) {
                    return (
                      <Image slug={slug} id={screenshots[key]['id']} title={screenshots[key]['title']} content={screenshots[key]['content']} />
                    )
                  })
                }
              </div>
              <div className="section-title">Tech / Tools</div>
              <div className="section-copy">
                <ul>
                  <li>Designed assets in Adobe Photoshop</li>
                  <li>Developed frontend with Python on Django, HTML, CSS and jQuery</li>
                </ul>
              </div>
              <div className="section-title">Press</div>
              <div className="section-copy">
                <ul>
                  <li><a href="https://www.techinasia.com/sgbeat-singapores-twitter-clone/">sgBEAT – Singapore&#039;s Twitter Clone</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/sgBEAT/index.js